import { useEffect } from "react";

export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title;
    const m = document.querySelector('meta[name="description"]');
    if (m) m.setAttribute("content", description);
    let c = document.querySelector('link[rel="canonical"]');
    if (!c) {
      c = document.createElement("link");
      c.setAttribute("rel", "canonical");
      document.head.appendChild(c);
    }
    c.setAttribute("href", "https://www.gtechitalia.it" + window.location.pathname);
  }, [title, description]);
}
